// extracted by mini-css-extract-plugin
export default {"container":"style_container__Xr6xv","image":"style_image__dcsPU","data":"style_data__6c6xn"};